import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import MuiSnackbar from '@mui/material/Snackbar';
import MuiSnackbarContent from '@mui/material/SnackbarContent';
import Typography from '@mui/material/Typography';

import { isMobileMedia } from 'bento-ordering/utils/media';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import {
  getButtonBackgroundHoverColor,
  getButtonFontHoverColor,
  getMenuItemNamesTypography
} from 'styles/helpers/getThemeStyles';

const StyledSnackbar = styled(MuiSnackbar)(({ theme }) => ({
  '&.MuiSnackbar-root': {
    position: 'absolute',
    top: '-100px',
    [theme.breakpoints.down('sm')]: {
      position: 'static',
      bottom: 'auto',
      margin: '5px 20px 0'
    }
  }
}));

const StyledSnackbarContent = styled(MuiSnackbarContent)(({ theme }) => ({
  '&.MuiSnackbarContent-root': {
    backgroundColor: getButtonBackgroundHoverColor(theme),
    width: '396px',
    borderRadius: '8px',
    paddingLeft: '18px',

    [theme.breakpoints.down('sm')]: {
      borderRadius: '4px'
    }
  }
}));

const MessageTitle = styled(Typography)(({ theme }) => {
  return {
    color: getButtonFontHoverColor(theme),
    fontSize: 16,
    ...getMenuItemNamesTypography(theme)
  };
});

const AlertMessage = styled(Typography)(({ theme }) => ({
  color: getButtonFontHoverColor(theme)
}));

export const ProductLeadTimeAlert = ({ alertMessage = '' }) => {
  if (!alertMessage) {
    return null;
  }

  const messageStyles = { variant: ITEM_DESCRIPTION_AND_PRICES };

  const getAlertMessage = () => (
    <>
      <MessageTitle variant="h6">
        Update time to when this item is available?
      </MessageTitle>
      <AlertMessage {...messageStyles}>{alertMessage}</AlertMessage>
    </>
  );

  return (
    <StyledSnackbar
      open
      anchorOrigin={{
        horizontal: 'center',
        vertical: isMobileMedia() ? 'bottom' : 'top'
      }}
    >
      <StyledSnackbarContent message={getAlertMessage()} />
    </StyledSnackbar>
  );
};

ProductLeadTimeAlert.propTypes = {
  alertMessage: PropTypes.string
};
